var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluterAndroidAppDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 51,
    viewBox: "0 0 32 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1191_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6422 13.0059H24.9784L9.27091 28.728L5.44531 24.8889L17.6422 13.0059Z",
    fill: "#E98432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8334 24.2041H24.4846L18.4087 30.4198L24.4846 37.0012H16.8334L10.9375 30.6026L16.8334 24.2041Z",
    fill: "#E98432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6341 2.08301H4.36551C2.57582 2.08301 1.125 3.55629 1.125 5.37368V46.5071C1.125 48.3245 2.57582 49.7978 4.36551 49.7978H27.6341C29.4238 49.7978 30.8746 48.3245 30.8746 46.5071V5.37368C30.8746 3.55629 29.4238 2.08301 27.6341 2.08301Z",
    stroke: "#F4C135",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1191_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 50,
    fill: "white",
    transform: "translate(0 0.94043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluterAndroidAppDev);
export default __webpack_public_path__ + "static/media/Fluter-android-app-dev.17a89c4f5a6d5aad657b24cd98e710ce.svg";
export { ForwardRef as ReactComponent };